var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-banner',{staticClass:"mb-2",attrs:{"color":"info"}},[_c('a',{attrs:{"href":_vm.getConverterUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('converter.link'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }